const latestArticle = {
  "status": "true",
  "message": "取得最新文章",
  "total": "3",
  "ArticleList": [
    {
      "title": "生成式AI發展機會：以人為本、跨域創新",
      "author": "蘇孟宗",
      "url": "https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=17&domain=82&sld_preid=7606",
      "image": `${require('assets/images/home/news-1.jpg')}`,
      "time": "2023/06/30"
    },
    {
      "title": "從產業環境掃描觀測AI發展趨勢",
      "author": "王允中",
      "url": "https://ieknet.iek.org.tw/iekrpt/rpt_detail.aspx?indu_idno=3&domain=44&rpt_idno=576226058",
      "image": `${require('assets/images/home/news-2.jpg')}`,
      "time": "2023/07/13"
    },
    {
      "title": "工研院IEKCQM：搭AI大勢 2024年製造業產值預估成長6.47%",
      "author": "陳佳楹",
      "url": "https://ieknet.iek.org.tw/iekrpt/rpt_detail.aspx?indu_idno=1&domain=2&rpt_idno=189996791",
      "image": `${require('assets/images/home/news-3.jpg')}`,
      "time": "2023/07/13"
    },
  ]
}

export default latestArticle;